// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36wAc","controls":"styles_controls__WG8Nr","charLimit":"styles_charLimit__280DJ","input":"styles_input__2wOuk","send":"styles_send__3JdmJ"};